﻿import searchInfo from  './searchInfo';
import creator from '../elementCreator';
import globals from '../globals';

"use strict";
var privateFns;
privateFns = {
	addButtonTriggers: function (intranett) {
		$("#large-search").focus(function (e) {
			$(e.currentTarget).val("");
		});
		$("#searchclear").click(function () {
			$("#large-search").val("");
		});
		$("#small-search-btn").click(function () {
			$(".drop-downs").hide();

			$(".show-collapsible").removeClass("show-collapsible");

			$("#searchinput").toggle();

			$("#large-search").val("").focus();
		});
		$(".hide-me").click(function (e) {
			$(e.currentTarget).closest(".drop-downs").hide(300);
			$(e.currentTarget).closest(".floating-win").hide(300);
		});
	},
	createSearchField: function(parameters){
		var form, inputcontainer, clickInfocontainer, input, clearbtn, inputbtn, submitbtn, icon;
		form = creator.createForm({id: "searchinput"});
		
		inputcontainer = creator.createDiv({id: "search-input-field", css: "btn-group input-group input-group-sm"});
		clickInfocontainer = creator.createDiv({id: "", css: "infoContainer", text: "Klikk i kartet for mer info"});
		
		input = creator.createInput({css: "searchinput", id: "large-search", name: "q"});
		input.type = "text";
		input.placeholder = parameters.placeholder;
		input.autocomplete = "off";
		input.setAttribute("aria-label", parameters.ariaLabel);
		
		inputbtn = creator.createSpan({css: "input-group-btn"});
		
		submitbtn = creator.createButton({css: "btn btn-default btn-search", id: "btn-searchbtn", ariaLabel: "Søk"});
		submitbtn.type = "submit";
		
		icon = creator.createIcon({css: "icon-Search-big"});
		
		submitbtn.appendChild(icon);
		inputbtn.appendChild(submitbtn);
		inputcontainer.appendChild(input);
		inputcontainer.appendChild(inputbtn)
		form.appendChild(inputcontainer);
		document.getElementById("middleDiv").appendChild(form);
		
		privateFns.createSmallSearchBtn();
	},
	createSmallSearchBtn: function(){
		let smallSearchBtn = creator.createButton({css: "top-menu-button small-screen", id: "small-search-btn", title: "Søk på adresse, eiendom, plan eller sak", ariaLabel: "Søk på adresse, eiendom, plan eller sak.", text: '<i class="glyphicon glyphicon-search"></i>'});
		document.getElementById("middleDiv").appendChild(smallSearchBtn);
	},
	initPlainSearch: function () {
		privateFns.addButtonTriggers(true);
		var input = $("#large-search");
		input.closest("form").submit(function (e) {
			e.preventDefault();
			searchInfo.submitSearch(input.val());
		});
	},
	
	initAutocomplete: function (parameters) {
		var input = $("#large-search");
		input.attr("placeholder", "Vent...");
		/* https://www.devbridge.com/sourcery/components/jquery-autocomplete/ */
		$.ajax({
			url: globals.autocompleteUrl,
			success: function (a) {
				//var data = JSON.parse(a);
				var data = a;
				data.sort((a,b) => (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0));
				input.autocomplete({
					lookup: data,
					minChars: 3,
					dataKey: "data",
					searchKey: "value",
					searchEverywhere: false,
					lookupLimit: 10,
					width: 320,
					onSelect: function (suggestion) {
						var selected = $("#selected");
						selected.find("span").html(suggestion.value);
						selected.addClass("selected");
						parameters.autocompleteHandlers.forEach(function(element){
							if(suggestion.data === element.key){
								searchInfo[element.func](suggestion.value);
							}
						});
					}
				});
				input.attr("placeholder",  parameters.placeholder);
			}
		});
	},
};
$("head").append("<link rel='stylesheet' type='text/css' href='./css/searchPlugin.css'>");
export default {
	initiate: function(parameters){
		if(parameters){
			privateFns.createSearchField(parameters);
			privateFns.initAutocomplete(parameters);
			privateFns.initPlainSearch();
		}
	},
};
